module.exports = __webpack_public_path__ + "static/img/kjdy18.aa784f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy18.png
// module id = 333
// module chunks = 0